import type { SVGProps } from "react";
export default function SvgGoNoGoApp(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 162 187"
			{...props}
		>
			<foreignObject width={152.676} height={180.683} x={0} y={6.31738}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1094_1359_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_ddddi_1094_1359)">
				<path
					fill="url(#paint0_linear_1094_1359)"
					fillOpacity={0.6}
					d="M108.012 24.317H44.664A4.664 4.664 0 0 0 40 28.982v63.354A4.664 4.664 0 0 0 44.664 97h63.348a4.664 4.664 0 0 0 4.664-4.664V28.982a4.664 4.664 0 0 0-4.664-4.665"
				/>
				<path
					stroke="url(#paint1_linear_1094_1359)"
					d="M44.664 24.817h63.348a4.164 4.164 0 0 1 4.164 4.164v63.355c0 2.3-1.865 4.164-4.164 4.164H44.664a4.165 4.165 0 0 1-4.164-4.164V28.98c0-2.3 1.865-4.164 4.164-4.164Z"
				/>
			</g>
			<g filter="url(#filter1_ddddi_1094_1359)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M116.967 83.56 100.35 70.436a4.66 4.66 0 0 0-5.779 0L77.954 83.56c-2.037 1.611-5.035.159-5.035-2.439V20.284A5.283 5.283 0 0 1 78.202 15h38.514A5.283 5.283 0 0 1 122 20.284v60.838c0 2.597-2.998 4.05-5.036 2.438z"
				/>
				<path
					stroke="url(#paint2_linear_1094_1359)"
					strokeOpacity={0.5}
					d="M78.202 15.5h38.514a4.784 4.784 0 0 1 4.784 4.784v60.837c0 2.165-2.481 3.38-4.189 2.073l-.034-.026-16.617-13.125a5.16 5.16 0 0 0-6.398 0L77.644 83.168c-1.71 1.352-4.225.133-4.225-2.047V20.284a4.783 4.783 0 0 1 4.783-4.784Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				d="m98.8 30.288 2.863 4.854a1.56 1.56 0 0 0 1.003.73l5.502 1.222a1.555 1.555 0 0 1 .828 2.548l-3.733 4.223c-.285.323-.424.75-.383 1.179l.539 5.61a1.555 1.555 0 0 1-2.168 1.573l-5.168-2.245a1.55 1.55 0 0 0-1.24 0l-5.167 2.245a1.555 1.555 0 0 1-2.168-1.573l.54-5.61a1.56 1.56 0 0 0-.384-1.18l-3.733-4.222a1.555 1.555 0 0 1 .827-2.548l5.503-1.223c.42-.092.784-.357 1.003-.729l2.862-4.854a1.554 1.554 0 0 1 2.678 0z"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_1094_1359"
					x1={76.5231}
					x2={76.5231}
					y1={24.3174}
					y2={96.9997}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1094_1359"
					x1={76.3378}
					x2={49.4997}
					y1={25.1134}
					y2={84.7502}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1094_1359"
					x1={97.4593}
					x2={97.4593}
					y1={15}
					y2={84.2358}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<filter
					id="filter0_ddddi_1094_1359"
					width={152.676}
					height={180.683}
					x={0}
					y={6.31738}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1359" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1359"
						result="effect2_dropShadow_1094_1359"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1359"
						result="effect3_dropShadow_1094_1359"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1359"
						result="effect4_dropShadow_1094_1359"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1359" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1359" />
				</filter>
				<filter
					id="filter1_ddddi_1094_1359"
					width={129.081}
					height={177.235}
					x={32.9189}
					y={-3}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={10} />
					<feGaussianBlur stdDeviation={12} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.1 0" />
					<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1094_1359" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={40} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0.419608 0 0 0 0 0.658824 0 0 0 0 0.717647 0 0 0 0.09 0" />
					<feBlend
						in2="effect1_dropShadow_1094_1359"
						result="effect2_dropShadow_1094_1359"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={15} />
					<feColorMatrix values="0 0 0 0 0.0620791 0 0 0 0 0.165757 0 0 0 0 0.220065 0 0 0 0.02 0" />
					<feBlend
						in2="effect2_dropShadow_1094_1359"
						result="effect3_dropShadow_1094_1359"
					/>
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={50} />
					<feGaussianBlur stdDeviation={20} />
					<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
					<feBlend
						in2="effect3_dropShadow_1094_1359"
						result="effect4_dropShadow_1094_1359"
					/>
					<feBlend in="SourceGraphic" in2="effect4_dropShadow_1094_1359" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect5_innerShadow_1094_1359" />
				</filter>
				<clipPath id="bgblur_0_1094_1359_clip_path" transform="translate(0 -6.317)">
					<path d="M108.012 24.317H44.664A4.664 4.664 0 0 0 40 28.982v63.354A4.664 4.664 0 0 0 44.664 97h63.348a4.664 4.664 0 0 0 4.664-4.664V28.982a4.664 4.664 0 0 0-4.664-4.665" />
				</clipPath>
			</defs>
		</svg>
	);
}
